import * as Yup from "yup";

import React, { useState } from "react";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";
import { requestPassword } from "../_redux/authCrud";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useFormik } from "formik";

const LoginWrapper = styled.div`
    position: absolute;
    top: 65%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    background: rgba(30, 30, 45, 0.8);
    color: #fff;
    padding: 1rem;
    width: 40vw;
    min-width: 300px;
    max-width: 400px;
    border-radius: 0.5rem;
    @media only screen and (min-width: 768px){
      padding: 3rem;
      top: 50%;
    }
`;

const InputLogin = styled.input`
  border: none;
  border-bottom: 1px solid #fff;
  font-weight: bold;
  border-radius: 0;
  &::placeholder {
    color: #fff;
    opacity: 1;
  }
`;

const Title = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const Logos = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 10vw;
  height: 20vh;
  min-width: 80px;
  @media only screen and (min-width: 1141px){
    width: 8vw;
    height: 20vh;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
`;

function ForgotPassword() {
  const [loading, setLoading] = useState(false);

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email("Format email salah").required("Wajib diisi"),
  });

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setLoading(true);
      requestPassword(values.email)
        .then(() => {
          setLoading(false);
          setSubmitting(false);
          resetForm();
          toast.success(
            "Jika email terdaftar, tautan reset kata sandi telah dikirim."
          );
        })
        .catch(() => {
          setLoading(false);
          setSubmitting(false);
          toast.success(
            "Jika email terdaftar, tautan reset kata sandi telah dikirim."
          );
        });
    },
  });

  return (
    <Wrapper>
      <Logos>
        <img src={`${toAbsoluteUrl("/media/logos/mynet.png")}`} alt="MYNET" />
      </Logos>
      <Title>
        <h4>Sistem Informasi Mynet Terpadu</h4>
      </Title>
      <LoginWrapper>
        <h1 className="mb-2">Lupa Kata Sandi ?</h1>
        <p className="text-white-50 mb-6">
          Masukkan email Anda untuk menerima tautan reset kata sandi.
        </p>
        <form className="form row" onSubmit={formik.handleSubmit}>
          <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <InputLogin
              className="form-control h-auto text-white bg-white-o-5"
              type="email"
              placeholder="Email"
              name="email"
              autoComplete="username"
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.email}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group col-6">
            <Link to="/auth/login" className="btn btn-warning btn-block">
              Batal
            </Link>
          </div>
          <div className="form-group col-6">
            <button
              type="submit"
              className="btn btn-success btn-block"
              disabled={formik.isSubmitting}
            >
              <span>Kirim</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </form>
      </LoginWrapper>
    </Wrapper>
  );
}

export default ForgotPassword;
